import { render, staticRenderFns } from "./_HotelPorterageHover.vue?vue&type=template&id=a213a542"
import script from "./_HotelPorterageHover.vue?vue&type=script&lang=js"
export * from "./_HotelPorterageHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports